import { prefixerC } from '.'

export const ROUTE_TRANSACCION_TRIBUTARIA = prefixerC('transaccion-tributaria')
export const ROUTE_COMPROBANTE_AUTORIZADO = prefixerC('comprobante-autorizado')
export const ROUTE_PARAMETROS_RDEP = prefixerC('parametros-rdep')
export const ROUTE_CIERRE_SRI = prefixerC('cierre-sri')
export const ROUTE_MATRIZ_TIPO_CONTRIBUYENTE = prefixerC('matriz-tipo-contribuyente')
export const ROUTE_CONCEPTOS_RETENCION_FUENTE = prefixerC('conceptos-retencion-fuente')
export const ROUTE_CAMPOS_FORMULARIO_103 = prefixerC('campos-formulario-103')
